import {
  ATENDABOT_PRODUCT_IMAGE,
  PRODUCT_IMAGES,
} from '../branding/assets';

export const PRODUCT_CATALOG = [
  {
    nome: 'atendabot',
    imagem: ATENDABOT_PRODUCT_IMAGE,
    backgroundColor: '#3127A0',
    link: '/atendabot',
    logoSize: '200px',
    productKey: 'atendabot',
  },
  {
    nome: 'LinkPage',
    imagem: PRODUCT_IMAGES.linkPage,
    backgroundColor: '#f2f3f3',
    link: '/links',
    logoSize: '260px',
    productKey: 'linkpage',
    activationDisabled: true,
  },
  {
    nome: 'Clube de Mesa',
    imagem: PRODUCT_IMAGES.clube,
    backgroundColor: '#F0E6DC',
    link: '/clube',
    logoSize: '250px',
    productKey: 'clube_mesa',
    comingSoon: true,
    comingSoonDescription:
      'Faça seus clientes voltarem mais vezes. Programa de fidelidade com recompensas e benefícios exclusivos.',
  },
  {
    nome: 'Feedback Hero',
    imagem: PRODUCT_IMAGES.feedbackHero,
    backgroundColor: '#143023',
    link: '/feedback-hero',
    logoSize: '250px',
    productKey: 'feedback_hero',
  },
  {
    nome: 'ClientCenter CRM',
    imagem: PRODUCT_IMAGES.clientCenter,
    backgroundColor: '#fbfbfc',
    link: '/crm',
    logoSize: '350px',
    productKey: 'crm',
    activationDisabled: true,
  },
  {
    nome: 'ChefList',
    imagem: PRODUCT_IMAGES.chefList,
    backgroundColor: '#fff',
    link: '/checklist',
    logoSize: '250px',
    productKey: 'checklist',
    comingSoon: true,
    comingSoonDescription:
      'Cozinha rodando redondinha todo dia. Checklists digitais, lembretes automáticos e auditoria de tudo.',
  },
  {
    nome: 'Reservo',
    imagem: PRODUCT_IMAGES.reservo,
    backgroundColor: '#ffdb2f',
    link: '/reservo',
    logoSize: '250px',
    productKey: 'reservo',
  },
  {
    nome: 'One Menu',
    imagem: PRODUCT_IMAGES.oneMenu,
    backgroundColor: '#fff6f3',
    link: '/cardapio',
    logoSize: '210px',
    productKey: 'cardapio',
  },
  {
    nome: 'CurriculoCerto',
    imagem: PRODUCT_IMAGES.cv,
    backgroundColor: '#000',
    link: '/cv',
    logoSize: '140px',
    productKey: 'cv',
  },
];

export const PUBLIC_PRODUCT_CATALOG = PRODUCT_CATALOG.filter(
  (product) => !product.comingSoon
);

export const PUBLIC_PRODUCT_KEYS = PUBLIC_PRODUCT_CATALOG.map(
  (product) => product.productKey
);
